import { useEffect as r } from "react";
import { b as c } from "./react-B_GApDuV.js";
const u = (t, o) => {
  const [e, s] = c(t);
  r(() => {
    o !== void 0 && e !== o && s(() => o);
  }, [o]);
}, i = (t, o) => {
  const [e, s] = c(t);
  r(() => {
    o !== void 0 && s(o);
  }, []);
};
export {
  i as a,
  u
};
//# sourceMappingURL=use-sync-atom-value-CDr7vapO.js.map
